export const PRODUCT_REVIEW_REWARD_TYPE = {
  user_credit: 'user_credit',
  member_point: 'member_point',
};
